import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';

// Source of truth for USCG symbology
const USCG_CONFIG = {
  absorbentMaterial: { label: 'Absorbent Material', geometry: 'single' },
  boatRamp: { label: 'Boat Ramp', geometry: 'single' },
  proposedBoom: { label: 'Boom', geometry: 'line' },
  completedBoom: { label: 'Completed Boom', geometry: 'line' },
  branch1: { label: 'Branch 1', geometry: 'single' },
  branch2: { label: 'Branch 2', geometry: 'single' },
  branchBoundary: { label: 'Branch Boundary', geometry: 'single' },
  divisionA: { label: 'Division A', geometry: 'single' },
  divisionB: { label: 'Division B', geometry: 'single' },
  divisionBoundary: { label: 'Division Boundary', geometry: 'single' },
  emergencyOperationsCenter: {
    label: 'Emergency Operations Center',
    geometry: 'single',
  },
  fireStation: { label: 'Fire Station', geometry: 'single' },
  firstAidSection: { label: 'First Aid Section', geometry: 'single' },
  hazardOrigin: { label: 'Hazard Origin', geometry: 'single' },
  helibase: { label: 'Helibase', geometry: 'single' },
  helispot: { label: 'Helispot', geometry: 'single' },
  holtCamp: { label: 'Holt Camp', geometry: 'single' },
  hospital: { label: 'Hospital', geometry: 'single' },
  incidentBase: { label: 'Incident Base', geometry: 'single' },
  incidentCommandPost: { label: 'Incident Command Post', geometry: 'single' },
  jointInformationCenter: {
    label: 'Joint Information Center',
    geometry: 'single',
  },
  mobileRelay: { label: 'Mobile Relay', geometry: 'single' },
  mobileWeatherUnit: { label: 'Mobile Weather Unit', geometry: 'single' },
  oilSpill: { label: 'Oil or Chemical Plume', geometry: 'line' },
  oilSpillPrediction: { label: 'Oil Spill Prediction', geometry: 'single' },
  customPolygon: { label: 'Polygon', geometry: 'polygon' },
  policeStation: { label: 'Police Station', geometry: 'single' },
  redfernStagingArea: { label: 'Redfern Staging Area', geometry: 'single' },
  safetySecurityZone: { label: 'Safety/Security Zone', geometry: 'single' },
  telephone: { label: 'Telephone', geometry: 'single' },
  windSpeedAndDirection: {
    label: 'Wind Speed and Direction',
    geometry: 'single',
  },
} as const;

export type UscgSymbol = keyof typeof USCG_CONFIG;
export type SymbolGeometryType = 'single' | 'line' | 'polygon';

export const getSymbolSvgUrl = (name: UscgSymbol) => {
  return new URL(`../symbols/${name}.svg`, import.meta.url).href;
};

export const symbolToGeometryTypeMap = Object.fromEntries(
  Object.entries(USCG_CONFIG).map(([key, val]) => [key, val.geometry])
) as Record<UscgSymbol, SymbolGeometryType>;

export const symbolToPictureMarkerMap = Object.fromEntries(
  (Object.keys(USCG_CONFIG) as UscgSymbol[]).map((key) => [
    key,
    new PictureMarkerSymbol({
      url: getSymbolSvgUrl(key),
      width: '32px',
      height: '32px',
    }),
  ])
) as Record<UscgSymbol, PictureMarkerSymbol>;

export const USCG_SYMBOLOGY_OPTIONS = (
  Object.entries(USCG_CONFIG) as [
    UscgSymbol,
    (typeof USCG_CONFIG)[UscgSymbol],
  ][]
).map(([type, config]) => ({
  type,
  label: config.label,
  iconSrc: getSymbolSvgUrl(type),
}));
